import { deleteEmployee, addEmployee } from "../services/userService";
import { UserContent } from "../edit-user/component/types";
import { enrichUsersData } from "src/shared/utils/userUtils";
import { notifyError } from "src/assets/toastService";

export const update = (customerdata: any, setloading: Function, onSuccess?: Function) => {
  setloading(true);
  return addEmployee(customerdata)
    .then(() => {
      setloading(false);
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((error: any) => {
      console.error("Error during user upload:", error);
      setloading(false);
      const message = error.response?.data?.message;
      if (message === "Email Already Exists") {
        notifyError("Email already exists");
      } else if (message === "Username Already Exist") {
        notifyError("Username already exists");
      } else {
        notifyError("An error occurred");
      }
      throw error;
    });
};

export const deleteUser = (id: string | number, setTempId: Function, setEmployeedata: Function, setFilteredData: Function) => {
  deleteEmployee(id)
    .then(() => {
      setTempId("");
      setEmployeedata((prevData: any[]) => prevData.filter((item) => item._id.$oid !== id));
      setFilteredData((prevData: any[]) => prevData.filter((item) => item._id.$oid !== id));
    })
    .catch((error) => {
      console.error("Error deleting user:", error);
      notifyError("Failed to delete user");
    });
};

export const filters = (value: boolean, api: any, setfear: Function, setEmployeedata: Function, setFilteredData: Function, setLoading?: Function) => {
  // Set loading to true if provided
  if (setLoading) setLoading(true);
  if (value === true) {
    api
      .get(`/pos/v2/add_employee/DeletedUsers`)
      .then((res: any) => {
        const emergency: UserContent[] = res.data.result;
        setfear(emergency);
        if (res.data.message === "No deleted users found") {
          const err = res.data.message;
          notifyError(err);
        }
        const userData = res.data.result;
        if (userData) {
          // ✅ Use the enrichUsersData utility to ensure proper structure
          const enrichedData = enrichUsersData(userData);
          setEmployeedata(enrichedData);
          setFilteredData(enrichedData);
        }
        // Set loading to false after success
        if (setLoading) setLoading(false);
      })
      .catch((error: any) => {
        const err = error.response?.data?.message || "An unknown error occurred";
        notifyError(err);
        // Set loading to false after error
        if (setLoading) setLoading(false);
      });
  } else {
    api.get(`/pos/v2/get_user`).then((res: any) => {
      const userData = res.data.result.filter((data: any) => data.userName !== null && data.userName !== undefined);

      // ✅ Use the enrichUsersData utility to ensure proper structure
      const enrichedData = enrichUsersData(userData);

      setEmployeedata(enrichedData);
      setFilteredData(enrichedData);
    });
  }
};
